import script from "./ConversationHeader.vue?vue&type=script&lang=ts&setup=true"
export * from "./ConversationHeader.vue?vue&type=script&lang=ts&setup=true"

import "./ConversationHeader.vue?vue&type=style&index=0&id=c1bec570&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c1bec570"]])

export default __exports__